import React from 'react';

import {
  errorUtil,
  fields,
  formUtil
} from 'iron-forge-react-modules';
import {
  BaseTier1ReturnAuthorizationModal,
  selectFields
} from 'modules/layer01';

import { useForm } from 'react-hook-form';
import { Stack } from '@mui/material';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  returnAuthorizationId: string;
  storeId: string;

  onClose: () => void;
  onFinish: () => void;
}

export const FC: React.FC<IProps> = props => {
  const { genController } = selectFields.RepairCodeSelectField.genComponentAndControllerGenerator(props.storeId);
  const ControlledRepairCodeSelectField = genController<types.IFormState>();

  const queryTuple = dataService.useQuery(props.returnAuthorizationId);
  const [triage, triageTuple] = dataService.useTriageTier1ReturnAuthorization(props.returnAuthorizationId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      creditedSerialNumber: '',
      repairCode: null
    }
  });
  formUtil.useSetFormFields(queryTuple, form.setValue, ['creditedSerialNumber']);

  const processSubmit = React.useCallback(
    async (formState: types.IFormState) => {
      if (queryTuple.data.triageWorkflowId) {
        await errorUtil.errorWrap(async () => {
          await triage(formState, queryTuple.data.triageWorkflowId);
          props.onFinish();
        });
      }
    },
    [
      props,
      queryTuple.data.triageWorkflowId,
      triage
    ]
  );

  const loading = queryTuple.loading || triageTuple.loading;

  return (
    <BaseTier1ReturnAuthorizationModal.FC
      title="Credit RMA"
      primaryText="Review and confirm to credit the RMA"
      secondaryText="Review the item before proceeding"
      disableButtons={loading}
      onClose={props.onClose}
      onSubmit={form.handleSubmit(processSubmit)}>
      <Stack>
        <ControlledRepairCodeSelectField
          label="Repair Code"
          fieldKey="repairCode"
          formControl={form.control} />

        <ControlledTextField
          label="IMEI/ICCID"
          fieldKey="creditedSerialNumber"
          isDisabled
          formControl={form.control} />
      </Stack>
    </BaseTier1ReturnAuthorizationModal.FC>
  );
};
